
import { logError } from "@/utils/logError";
import { Component, Vue } from "vue-property-decorator";

import BaseCurrency from "./BaseCurrency.vue";
import Currency from "./Currency.vue";

@Component({
  components: {
    BaseCurrency,
    Currency
  }
})
export default class Currencies extends Vue {
  private rates: Array<{ [currency: string]: number }> = [];
  private symbols: string[] = ["USD", "EUR", "GBP", "RUB", "THB", "TRY", "HKD", "ARS"];
  private base = "USD";

  mounted() {
    this.getCurrencies();
  }

  getCurrencies() {
    const headers = new Headers();
    headers.append("apikey", process.env.VUE_APP_API_KEY);

    fetch(
      `https://api.apilayer.com/exchangerates_data/latest?base=${
        this.base
      }&symbols=${this.symbols.join()}`,
      { headers }
    )
      .then(stream => stream.json())
      .then(data => (this.rates = data.rates))
      .catch(logError);
  }

  onBaseChange(value: "EUR" | "USD") {
    this.base = value;
    this.getCurrencies();
  }
}
